import SectionHeader from "@/components/SectionHeader";

export default function SEOFooterContent({ title, htmlContent }) {
  const defaultTitle = "Worauf du beim Mieten einer Fotobox achten solltest";

  return (
    <SectionHeader title={title || defaultTitle}>
      {htmlContent ? (
        <div
          className="text-[16px] mt-5 footer-text text-slate-900"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      ) : (
        <div className="text-[16px] mt-5 footer-text text-slate-900">
          <p>
            Wer eine Fotobox mieten möchte, sollte Preis, Ausstattung,
            Druckoptionen und Service im direkten Vergleich prüfen. Unterschiede
            zeigen sich nicht nur beim Gesamtpreis, sondern vor allem bei
            Bildqualität, Druckleistung und enthaltenen Leistungen.
          </p>

          <span className="font-bold">In Kürze: Darauf kommt es an</span>
          <ul>
            <li>Bildqualität und Beleuchtung</li>
            <li>Druckoption (Flatrate oder Kontingent)</li>
            <li>Versand oder Vor-Ort-Service</li>
            <li>Online-Galerie und Downloadmöglichkeiten</li>
            <li>Service und Support im Problemfall</li>
          </ul>

          <h3>Die wichtigsten Kriterien im Überblick</h3>
          <ul>
            <li>
              <strong>Bildqualität:</strong> Spiegelreflexkamera oder einfache
              Webcam?
            </li>
            <li>
              <strong>Beleuchtung:</strong> LED-Ring, Studioblitz oder
              integriertes Dauerlicht?
            </li>
            <li>
              <strong>Druckoption:</strong> Einzelbilder oder Druck-Flatrate?
            </li>
            <li>
              <strong>Digitale Galerie:</strong> Download per QR-Code oder
              Online-Zugriff?
            </li>
            <li>
              <strong>Lieferung & Aufbau:</strong> Versandbox oder
              Vor-Ort-Service?
            </li>
            <li>
              <strong>Support:</strong> Ansprechpartner im Problemfall
              erreichbar?
            </li>
          </ul>
          <p>
            Diese Punkte entscheiden darüber, ob die Fotobox technisch
            zuverlässig funktioniert und den Erwartungen deiner Gäste
            entspricht.
          </p>

          <h3>Versand-Fotobox oder lokaler Anbieter?</h3>
          <p>Grundsätzlich gibt es zwei Modelle:</p>
          <span className="font-bold">1. Versand-Fotobox</span>
          <ul>
            <li>Werden vor dem Event geliefert</li>
            <li>Eigenständiger Aufbau</li>
            <li>Meist günstiger</li>
            <li>Ideal für private Feiern</li>
          </ul>

          <span className="font-bold">2. Lokaler Anbieter</span>
          <ul>
            <li>Aufbau und Abholung inklusive</li>
            <li>Persönlicher Service</li>
            <li>Höherer Preis durch Vor-Ort-Betreuung</li>
            <li>Geeignet für größere Events oder Firmenveranstaltungen</li>
          </ul>
          <p>
            Welche Variante sinnvoll ist, hängt von Budget, Eventgröße und
            gewünschtem Komfort ab.
          </p>

          <h3>Mit welchen Kosten musst du rechnen?</h3>
          <p>
            Die Preise für eine Fotobox variieren je nach Ausstattung und
            Leistungsumfang. Entscheidende Faktoren sind:
          </p>
          <ul>
            <li>Druck-Flatrate oder Druckkontingent</li>
            <li>Mietdauer</li>
            <li>Branding-Möglichkeiten</li>
            <li>Zusatzoptionen wie Hintergründe oder Requisiten</li>
            <li>Lieferung oder Selbstabholung</li>
          </ul>
          <p>
            Ein reiner Preisvergleich reicht deshalb selten aus – wichtiger ist
            das Verhältnis aus Leistung und Kosten. Wenn du eine Fotobox mieten
            willst, lohnt es sich, Paketinhalte statt nur den Preis zu
            vergleichen.
          </p>

          <h3>Jetzt passende Fotobox vergleichen</h3>
          <p>
            Ein strukturierter Vergleich hilft dir, Unterschiede schnell zu
            erkennen und die passende Lösung für dein Event zu finden –
            unabhängig davon, ob du eine Versandbox oder einen lokalen Anbieter
            bevorzugst.
          </p>
        </div>
      )}
    </SectionHeader>
  );
}
